/**
 * Zelsu Collection Enhancements
 * Sort pill dropdown · Video on hover · Wishlist heart pop
 */

// ── Sort By Pill Dropdown ─────────────────────────────────────────
function initSortByPill() {
  const containers = document.querySelectorAll('.zelsu-sortby');
  if (!containers.length) return;

  containers.forEach(container => {
    const trigger = container.querySelector('[data-sortby-trigger]');
    const options = container.querySelectorAll('.zelsu-sortby__option');
    if (!trigger) return;

    trigger.addEventListener('click', e => {
      e.stopPropagation();

      // On mobile, delegate to existing sort sheet trigger
      if (window.innerWidth < 768) {
        const mobileBtn = document.querySelector('.m-sortby--open');
        if (mobileBtn) mobileBtn.click();
        return;
      }

      const isOpen = container.hasAttribute('data-open');
      // Close any other open sortby dropdowns
      document.querySelectorAll('.zelsu-sortby[data-open]').forEach(c => {
        if (c !== container) c.removeAttribute('data-open');
      });
      if (isOpen) {
        container.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        container.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    options.forEach(option => {
      option.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', option.dataset.value);
        window.location.href = url.toString();
      });
    });
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (!e.target.closest('.zelsu-sortby')) {
      document.querySelectorAll('.zelsu-sortby[data-open]').forEach(c => {
        c.removeAttribute('data-open');
        const t = c.querySelector('[data-sortby-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.zelsu-sortby[data-open]').forEach(c => {
        c.removeAttribute('data-open');
        const t = c.querySelector('[data-sortby-trigger]');
        if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
      });
    }
  });
}

// ── Video on Hover ────────────────────────────────────────────────
function videoEnter(wrap) {
  const type = wrap.dataset.mediaType;

  if (type === 'video') {
    const video = wrap.querySelector('video');
    if (!video) return;
    video.muted = true;
    const p = video.play();
    if (p && p.catch) {
      p.catch(() => {
        // First play attempt failed — load then retry once
        video.load();
        video.play().catch(() => {});
      });
    }

  } else if (type === 'external_video') {
    if (wrap.querySelector('iframe')) return;
    const host = wrap.dataset.videoHost;
    const id   = wrap.dataset.videoId;
    if (!id) return;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');
    iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;';

    if (host === 'youtube') {
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&modestbranding=1&rel=0`;
    } else if (host === 'vimeo') {
      iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&loop=1&background=1`;
    }
    wrap.appendChild(iframe);
  }
}

function videoLeave(wrap) {
  const type = wrap.dataset.mediaType;

  if (type === 'video') {
    const video = wrap.querySelector('video');
    if (video) { video.pause(); video.currentTime = 0; }

  } else if (type === 'external_video') {
    const iframe = wrap.querySelector('iframe');
    if (iframe) iframe.remove();
  }
}

function attachVideoHover(mediaEl) {
  if (mediaEl._zelsuVideoInit) return; // already wired
  const wrap = mediaEl.querySelector('.m-product-card__video-hover');
  if (!wrap) return;
  mediaEl._zelsuVideoInit = true;
  mediaEl.addEventListener('mouseenter', () => videoEnter(wrap));
  mediaEl.addEventListener('mouseleave', () => videoLeave(wrap));
}

function initVideoHover() {
  // Wire existing cards
  document.querySelectorAll('.m-product-card__media').forEach(attachVideoHover);

  // Wire cards added later (infinite scroll / load more)
  new MutationObserver(mutations => {
    for (const mut of mutations) {
      for (const node of mut.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('m-product-card__media')) {
          attachVideoHover(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.m-product-card__media').forEach(attachVideoHover);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

// ── Wishlist Heart Pop Animation ──────────────────────────────────
function initWishlistPop() {
  document.addEventListener('click', e => {
    const btn = e.target.closest('.m-wishlist-button');
    if (!btn) return;
    btn.classList.remove('zelsu-heart-popping');
    // Force reflow to restart animation
    void btn.offsetWidth;
    btn.classList.add('zelsu-heart-popping');
    btn.addEventListener('animationend', () => btn.classList.remove('zelsu-heart-popping'), { once: true });
  });
}

// ── Sidebar Close Cursor ──────────────────────────────────────────
function initSidebarCursor() {
  const section = document.querySelector('.facest-filters-section');
  if (!section) return;

  // Create cursor element once
  const cursor = document.createElement('div');
  cursor.className = 'zelsu-close-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 7l10 10M17 7L7 17" stroke="rgb(var(--color-background, 255 255 255))" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
  document.body.appendChild(cursor);

  let mouseX = 0, mouseY = 0;
  let posX = 0, posY = 0;
  let visible = false;

  // Smooth follow loop — lerp at 16% per frame
  ;(function loop() {
    posX += (mouseX - posX) * 0.16;
    posY += (mouseY - posY) * 0.16;
    cursor.style.left = Math.round(posX) + 'px';
    cursor.style.top  = Math.round(posY) + 'px';
    requestAnimationFrame(loop);
  })();

  document.addEventListener('mousemove', e => {
    mouseX = e.clientX;
    mouseY = e.clientY;

    const isOpen = section.classList.contains('sidebar-open');

    if (!isOpen) {
      if (visible) { visible = false; cursor.classList.remove('is-visible'); }
      return;
    }

    // Check against sidebar content (not overlay)
    const content = document.querySelector('.m-sidebar--content');
    if (!content) return;
    const r = content.getBoundingClientRect();
    const outside = e.clientX > r.right || e.clientX < r.left ||
                    e.clientY > r.bottom || e.clientY < r.top;

    if (outside && !visible) {
      // Snap to current mouse position on first appear — no flying-in effect
      posX = mouseX; posY = mouseY;
      visible = true;
      cursor.classList.add('is-visible');
    } else if (!outside && visible) {
      visible = false;
      cursor.classList.remove('is-visible');
    }
  });

  // Clean up when mouse leaves the window
  document.addEventListener('mouseleave', () => {
    if (visible) { visible = false; cursor.classList.remove('is-visible'); }
  });
}

// ── Filter Pill Buttons ───────────────────────────────────────────
function applyFilterPill(link) {
  if (link._zpDone) return;
  link._zpDone = true;

  const li = link.closest('.zelsu-filter-pill');
  const isActive = li && (li.classList.contains('is-active') || li.classList.contains('active'));

  // Pill styles as inline (wins over everything)
  const base = [
    'display:inline-flex',
    'align-items:center',
    'gap:6px',
    'padding:8px 14px 8px 10px',
    'border-radius:100px',
    'font-size:13px',
    'font-weight:500',
    'font-family:inherit',
    'text-decoration:none',
    'white-space:nowrap',
    'line-height:1',
    'cursor:pointer',
    'transition:border-color .2s,color .2s,background .2s,transform .2s,box-shadow .2s',
    isActive
      ? 'border:1.5px solid #111;background:#111;color:#fff'
      : 'border:1.5px solid #d1d5db;background:#fff;color:#6b7280',
  ].join(';');
  link.setAttribute('style', base);

  // Inject SVG icon before the text (only once)
  const svgInactive = '<svg aria-hidden="true" style="width:15px;height:15px;flex-shrink:0;display:block" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#d1d5db" stroke-width="1.5"/></svg>';
  const svgActive   = '<svg aria-hidden="true" style="width:15px;height:15px;flex-shrink:0;display:block" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="white"/><path d="M5 8.2l2 2 4-4.4" stroke="#111" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  link.insertAdjacentHTML('afterbegin', isActive ? svgActive : svgInactive);

  // Hover
  if (!isActive) {
    link.addEventListener('mouseenter', () => {
      link.style.borderColor = '#111';
      link.style.color       = '#111';
      link.style.transform   = 'translateY(-1.5px)';
      link.style.boxShadow   = '0 4px 12px rgba(0,0,0,.08)';
    });
    link.addEventListener('mouseleave', () => {
      link.style.borderColor = '#d1d5db';
      link.style.color       = '#6b7280';
      link.style.transform   = '';
      link.style.boxShadow   = '';
    });
  }
}

function initFilterPillButtons() {
  // Style the filter <ul> lists
  document.querySelectorAll('.zelsu-filter-pill').forEach(li => {
    const ul = li.parentElement;
    if (ul && !ul._zpListDone) {
      ul._zpListDone = true;
      ul.style.cssText += ';display:flex!important;flex-wrap:wrap!important;gap:8px!important;list-style:none!important;padding:4px 0!important;margin:0!important';
    }
    li.style.cssText += ';display:inline-flex!important;margin:0!important';
    const link = li.querySelector('a');
    if (link) applyFilterPill(link);
  });

  // Re-run after any DOM changes (filter apply reloads page, but design-mode re-renders use AJAX)
  new MutationObserver(muts => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('zelsu-filter-pill')) {
          const link = node.querySelector('a');
          if (link) applyFilterPill(link);
        }
        node.querySelectorAll && node.querySelectorAll('.zelsu-filter-pill a').forEach(applyFilterPill);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

// ── Boot ──────────────────────────────────────────────────────────
function initZelsuCollectionEnhancements() {
  initSortByPill();
  initVideoHover();
  initWishlistPop();
  initFilterPillButtons();
  initSidebarCursor();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initZelsuCollectionEnhancements);
} else {
  initZelsuCollectionEnhancements();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initZelsuCollectionEnhancements);
}
